import Dovia91 from '../Dovia 9/Dovia 9 (1).webp'
import Dovia92 from '../Dovia 9/Dovia 9 (2).webp'
import Dovia93 from '../Dovia 9/Dovia 9 (3).webp'
import Dovia94 from '../Dovia 9/Dovia 9 (4).webp'
import Dovia95 from '../Dovia 9/Dovia 9 (5).webp'
import Dovia96 from '../Dovia 9/Dovia 9 (6).webp'
import Dovia97 from '../Dovia 9/Dovia 9 (7).webp'
import Dovia98 from '../Dovia 9/Dovia 9 (8).webp'
import Dovia99 from '../Dovia 9/Dovia 9 (9).webp'
import Dovia910 from '../Dovia 9/Dovia 9 (10).webp'
import Dovia911 from '../Dovia 9/Dovia 9 (11).webp'
import Dovia912 from '../Dovia 9/Dovia 9 (12).webp'
import Dovia913 from '../Dovia 9/Dovia 9 (13).webp'

const Dovia9images =[
    Dovia91,Dovia92,Dovia93,Dovia94,Dovia95,Dovia96,Dovia97,Dovia98,Dovia99,Dovia910,Dovia911,Dovia912,Dovia913
]

export default Dovia9images;